import { ProductNames } from '../constants/ProductNames';

export const isFundraisingPage = (name: string | undefined) => {
  return (
    name === ProductNames.ProxyFundraising || name === ProductNames.Fundraising
  );
};

export const isCampaignPage = (name: string | undefined) => {
  return name === ProductNames.Campaign;
};

export const isTeamsPage = (name: string | undefined) => {
  return name?.includes('team');
};

export const isCharityPage = (name: string | undefined) => {
  return name === ProductNames.ProxyCharity;
};

export const isCrowdfundingPage = (name: string | undefined) => {
  return name === ProductNames.Crowdfunding;
};

export const getPageType = (name: string | undefined) => {
  switch (name) {
    case ProductNames.ProxyFundraising:
      return 'FUNDRAISING';
    case ProductNames.Crowdfunding:
      return 'CROWDFUNDING';
    default:
      return 'ONE_PAGE';
  }
};
